/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useContext, useEffect, useRef, useState } from 'react';
import { FastField, Field, FieldArray, Form, Formik, Reset } from 'formik';
import { useHistory, useRouteMatch } from 'react-router-dom';
import * as yup from 'yup';
import Switch from 'react-switch';
import Layout from 'components/Layout';
import InputField from 'components/Form/InputField';
import Row from 'components/Grid/Row';
import Col from 'components/Grid/Col';
import Button from 'components/Button';
import FormContainer from 'components/FormContainer';
import Label from 'components/Form/Label';
import TextField from 'components/Form/TextField';
import { Text } from 'components/Text';
import ContentCard from 'components/ContentCard';
import _, { initial, repeat } from 'lodash';
import { ButtonContainer, ButtonContent, ViewText, ContentTextarea, DialogConfirm, DialogRejected, ButtonContainerRow} from './styles';
import { FitinsurAPI, MessageCenter } from 'utils';
import MasksHelper from 'utils/src/masks';
import Colors from 'constants/Colors';
import {DayPicker} from 'react-day-picker';
import { GlobalAuthContext, GlobalLoaderContext, GlobalOperationContext } from 'store/context';
import Loader from 'components/Loader';
import TagsList from 'components/TagList';
import SearchField from 'components/Form/SearchField';
import ComboBox from 'components/Form/ComboBox3';
import Icon from 'components/Icon';
import Access from 'constants/Access';
import DialogAlertMessage from 'components/DialogAlertMessage';

export default function Person(props) {
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const operationContext = useContext(GlobalOperationContext);
  const isClient = authContext.enumProfile === 1 ? true : false;
  const match = useRouteMatch();
  const history = useHistory();
  const [validations, setValidations] = useState({});
  const formikRef = useRef(null);
  const masks = new MasksHelper();
  const [comboBoxSearch, setComboBoxSearch] = useState({});
  const [vazio, setvazio] = useState([]);
  const [contactType, setContactType] = useState(null);
  const [contactList, setContactList] = useState([]);
  const [hasPermission, setHasPermission] = useState(true);
  const [enquiryList, setEnquiryList] = useState([]);
  const [dialog, setDialog] = useState({
    visible: false,
    title: '',
    icon: 'exclamation',
    args: null
  });

  //redirect
  const goBack = () => {
    props.onCloseModal();
  }

  //validação de campo
  const createValidation = () => {
    let val = yup.object().shape({
      shortName: yup.string().required("* Required field"),
      fullName: yup.string().required("* Required field"),
      personType: yup.string().required("* Required field"),
      regulatoryId: yup.string().notRequired(),
      legalId: yup.string().notRequired(),
      legalIdDocumentType: yup.string().notRequired(),
      contactType: yup.string().required("* Required field"),
      description: yup.string().required("* Required field"),
      street: yup.string().notRequired(),
      number: yup.string().notRequired(),
      complement: yup.string().notRequired(),
      zipCode: yup.string().notRequired(),
      district: yup.string().notRequired(),
      city: yup.string().notRequired(),
      state: yup.string().notRequired(),
      country: contactType && contactType === 30 ? yup.string().required("* Required field") : yup.string().notRequired()

    });
    setValidations(val);
  }

  // main execution
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();


  async function permissionAccess() {
    const response = await fitinsur
      .requestAccess("", props.IdPerson ? "UPDATE" : "CREATE", Access.PERSON_EDIT, null, props?.idOperation, authContext.token)
      .then((response) => response.json())

    //const hasPermission = response && response.ret_code === 200;
    const hasPermission = response && response.ret_code === 200;
    setHasPermission(hasPermission);
  }

  const [initial, setInitial] = useState({
    shortName: '',
    fullName: '',
    personType: '',
    regulatoryId: '',
    legalId: '',
    legalIdDocumentType: {
      idDomain: '',
      domainDescription: '',
      idDomainType: '',
    },
    contactType: '',
    description: '',
    street: '',
    number: '',
    complement: '',
    zipCode: '',
    district: '',
    city: '',
    state: '',
    country: '',
  })

  const fieldRenderOptions = function (answerOptions) {
    let result = []
    answerOptions.forEach(element => {

      if (element.ID_COUNTRY) {
        result.push({
          label: element.COUNTRY_NAME,
          value: {
            idCountry: element.ID_COUNTRY,
            countryName: element.COUNTRY_NAME
          }
        });
      } else if (element.ID_DOMAIN) {
        result.push({
          label: element.DOMAIN_DESCRIPTION,
          value: {
            idDomain: element.ID_DOMAIN,
            domainDescription: element.DOMAIN_DESCRIPTION,
            idDomainType: element.ID_DOMAIN_TYPE
          }
        });
      }

    });
    return result;
  }

  const getComboBox = () => {

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestPersonCombobox()
      .then(res => res.json()).then(response => {
        loading.stop();
        setComboBoxSearch(response.ret_value);
        if (response.ret_code != 200) mc.error(response.ret_msg_details);
      }).catch(() => {
        loading.stop();
        mc.error("An error happened, please try again.");
      });
  }

  const getPerson = () => {
    if (props.idPerson) {
      loading.start();
      let idPerson = props.idPerson;
      fitinsur.setAuthToken(authContext.token);
      fitinsur.requestPerson(idPerson)
        .then(res => res.json()).then(response => {

          loading.stop();
          let respPerson, respContact, respLegalIdDocumentType, respComboPersonType, respComboContactType, respAddress;

          respPerson = response.ret_value.person.ret_value[0];
          respContact = response.ret_value.contact;
          respComboPersonType = response.ret_value.personType.ret_value[0];
          respComboContactType = response.ret_value.contactType.ret_value[0];
          respAddress = response.ret_value.address.ret_value[0];
          respLegalIdDocumentType = response.ret_value.legalIdDocumentType;

          setContactType(respComboContactType?.ID_DOMAIN);
          formikRef.current.values.shortName = respPerson.personFirstName;
          formikRef.current.values.fullName = respPerson.personLastName;
          formikRef.current.values.legalId = respPerson.legalPersonId;
          formikRef.current.values.regulatoryId = respPerson.susepNumber || 'N/A';
          formikRef.current.values.street = respAddress?.STREET_NAME;
          formikRef.current.values.number = respAddress?.DOOR_NUMBER;
          formikRef.current.values.complement = respAddress?.COMPLEMENTARY;
          formikRef.current.values.zipCode = respAddress?.ZIP_CODE;
          formikRef.current.values.district = respAddress?.DISTRICT;
          formikRef.current.values.city = respAddress?.CITY;
          formikRef.current.values.state = respAddress?.STATE;

          // objetos do combobox -------------------------------------------------------//

          //COUNTRY
          let country = {
            idCountry: respAddress?.ID_COUNTRY,
            countryName: respAddress?.COUNTRY,
          }
          formikRef.current.values.country = country;

          //PERSONTYPE
          let personCombo = {
            idDomain: respComboPersonType?.ID_DOMAIN,
            domainDescription: respComboPersonType?.DOMAIN_DESCRIPTION,
            idDomainType: respComboPersonType?.ID_DOMAIN_TYPE,
          }
          formikRef.current.values.personType = personCombo;

          //LEGALIDDOCUMENTTYPE
          personCombo = {
            idDomain: respLegalIdDocumentType?.ID_DOMAIN,
            domainDescription: respLegalIdDocumentType?.DOMAIN_DESCRIPTION,
            idDomainType: respLegalIdDocumentType?.ID_DOMAIN_TYPE,
          }
          formikRef.current.values.legalIdDocumentType = personCombo;

          //CONTACT TYPE
          personCombo = {
            idDomain: respComboContactType?.ID_DOMAIN,
            domainDescription: respComboContactType?.DOMAIN_DESCRIPTION,
            idDomainType: respComboContactType?.ID_DOMAIN_TYPE,
          }
          formikRef.current.values.contactType = personCombo;

          // ----------------------------------------------------------------------------//

          if (response.ret_code !== 200) mc.error(response.ret_msg_details);
        }).catch((error) => {
          console.log('ERROR', error);
          loading.stop();
          mc.error("An error happened, please try again.");
        });
    }
  }

  const getContacts = () => {
    if(props.idPerson) {
      const idPerson = props.idPerson;
  
      fitinsur.setAuthToken(authContext.token);
      fitinsur.requestListContacts(idPerson)
          .then(x => x.json())
          .then(resp => {
              if (resp.ret_code === 200) {
                setContactList(resp.ret_value);
              } else {
                
              }
          }).catch((error) => {
              mc.error(`There was an error while fetching your data: ${getContacts.name}\n` + error);
              console.error('fitPostReject - Error:', error);
          });
    }
  }

  const getEnquiries = () => {
    if(props.idPerson) {
      const idPerson = props.idPerson;
  
      fitinsur.setAuthToken(authContext.token);
      fitinsur.requestListEnquiries(idPerson)
          .then(x => x.json())
          .then(resp => {
              if (resp.ret_code === 200) {
                setEnquiryList(resp.ret_value);
              } else {
                
              }
          }).catch((error) => {
              mc.error(`There was an error while fetching your data: ${getEnquiries.name}\n` + error);
              console.error('fitPostReject - Error:', error);
          });
    }
  }

  useEffect(() => {
    async function loadContent() {
      await createValidation();
      await getComboBox();
      await getPerson();

    }
    loadContent();
  }, [initial]);

  useEffect(() => { 
    getContacts();
    createValidation();
    permissionAccess();
  }, []);

  useEffect(() => {
    getEnquiries();
  }, [props.idPerson])

  useEffect(() => { 
    getAnswerContact(contactType);
    createValidation();
  }, [contactType]);


  function handleDialog() {
    setDialog({
      visible: true,
      title: "Information",
      icon: "TimesCircle",
      args: null,
    })
  };

  function handleCancel() { 
    setDialog({
      visible: false,
      title: "",
      icon: "",
      args: null,
    })
  }

  const handleSubmit = (body) => {
    if (props.idPerson) {
      body.idPerson = props.idPerson;
    }
    
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestSavePerson(body)
      .then(res => res.json()).then(response => {
        if (response.ret_code !== 200) {
          mc.error(response.ret_msg_details)
          loading.stop();
          return;
        }
        mc.success("Registration successful!");
        loading.stop();
        goBack();
      }).catch(() => {
        loading.stop();
        mc.error("An error happened, please try again.");
      });

  }

  function getAnswerContact(type) {
    let correctStatus = [];

    if(type) {
      correctStatus = contactList.find(v => v.idDomain === type);
      formikRef.current.values.description = correctStatus?.description || '';
    }
  }

  
  function renderModalApproval(values) {
    const lengthEnquiries = enquiryList.length - 7;
  
    return (
      <DialogAlertMessage icon={dialog.icon} title={dialog.title}  show={dialog.visible} setDialog={setDialog}>
        <ContentTextarea>
          <Text>
            You are about to make changes into a party that is being used in the below deals.
            Please note that, after these changes are saved, all these deals will need to be manually re-processed to ensure consistency.
          </Text>
          {enquiryList.map((enquiry, index) => index + 1 <= 7 ? <p>{enquiry}</p> : <></>)}
          {enquiryList.length > 7 && <p>{`and ${lengthEnquiries} more`}</p>}
          <ButtonContainerRow>
            <ButtonContent><Button  style={{ marginLeft: 15 }} secundary onClick={() => handleCancel()}>CANCEL</Button></ButtonContent>
            <ButtonContent><Button style={{backgroundColor: Colors.BLUE, color: Colors.WHITE, marginLeft: 15}} onClick={() => handleSubmit(values)}>CONFIRM</Button></ButtonContent>
          </ButtonContainerRow>
        </ContentTextarea>
      </DialogAlertMessage>
    )
  }

  return (
    <React.Fragment>
        {dialog.visible && renderModalApproval(formikRef.current?.values)}
        <ViewText>
          <Text>*Required Fields</Text>
          <button onClick={(e) => { e.stopPropagation(); e.preventDefault() }} style={{ opacity: 0, width: 0, height: 0 }}></button>
        </ViewText>
      <Formik
        innerRef={formikRef}
        initialValues={initial}
        enableReinitialize={true}
        onSubmit={(values) => props.idPerson ? handleDialog() : handleSubmit(values)}
        validationSchema={validations}>
          
        {formikProps => (
          
          <Form>
            <Row>
              <Col lg={6} md={6} sm={6} xs={12}>
                <Field
                  name="shortName"
                  label="Short Name"
                  isRequired={true}
                  component={InputField}
                  disabled={!hasPermission}
                />
              </Col>
              <Col lg={6} md={6} sm={6} xs={12}>
                <Field
                  name="fullName"
                  label="Full Name"
                  isRequired
                  component={InputField}
                  disabled={!hasPermission}
                />
              </Col>
            </Row>

            <Row>
              <Col lg={6} md={6} sm={6} xs={12}>
                <Field
                  name="personType"
                  label="Person Type"
                  isRequired
                  options={fieldRenderOptions(comboBoxSearch.personType ? comboBoxSearch.personType : vazio)}
                  searchList={comboBoxSearch.personType ? comboBoxSearch.personType : vazio}
                  onChange={(e) => {formikProps?.setFieldValue(`personType`, e)}}
                  component={ComboBox}  
                  disabled={!hasPermission} 
                />
              </Col>
              <Col lg={6} md={6} sm={6} xs={12}>
                <Field
                  name="regulatoryId"
                  label="Regulatory ID"
                  onChange={(e) => { formikProps?.setFieldValue(`regulatoryId`, e);}}
                  component={InputField}
                  disabled={!hasPermission}
                />
              </Col>
            </Row>

            <Row>
              <Col lg={6} md={6} sm={6} xs={12}>
                <Field
                  name="legalId"
                  label="Legal ID"
                  component={InputField}
                  disabled={!hasPermission}
                />
              </Col>
              <Col lg={6} md={6} sm={6} xs={12}>
                <Field
                  name="legalIdDocumentType"
                  label="Legal ID Document Type"
                  options={fieldRenderOptions(comboBoxSearch.legalIdType ? comboBoxSearch.legalIdType : vazio)}
                  searchList={comboBoxSearch.legalIdType ? comboBoxSearch.legalIdType : vazio}
                  onChange={(e) => { formikProps?.setFieldValue(`legalIdDocumentType`, e); }}
                  component={ComboBox}
                  disabled={!hasPermission}
                />
              </Col>
            </Row>

            <Row>
              <Col lg={6} md={6} sm={6} xs={12}>
                <Field
                  name="contactType"
                  label="Contact Type"
                  isRequired={true}
                  options={fieldRenderOptions(comboBoxSearch.contactType ? comboBoxSearch.contactType : vazio)}
                  searchList={comboBoxSearch.contactType ? comboBoxSearch.contactType : vazio}
                  onChange={(e) => {
                    formikProps?.setFieldValue(`contactType`, e);
                    setContactType(e.idDomain);
                  }}
                  component={ComboBox}
                  disabled={!hasPermission}
                />
              </Col>
              <Col lg={6} md={6} sm={6} xs={12}>
                <Field
                  name="description"
                  label="Description"
                  component={InputField}
                  value={formikProps.values.description}
                  isRequired
                  disabled={!hasPermission}
                />
              </Col>
            </Row>
            {contactType == 30 && <>
              <Row>
                <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                  <Field
                    name="street"
                    label="Street"
                    component={InputField}
                    disabled={!hasPermission}
                  />
                </Col>
                <Col lg={6} md={6} sm={6} xs={12}>
                  <Field
                    name="number"
                    label="Number"
                    component={InputField}
                    disabled={!hasPermission}
                  />
                </Col>
              </Row>

              <Row>
                <Col lg={4} md={4} sm={4} xs={12}>
                  <Field
                    name="complement"
                    label="Complement"
                    component={InputField}
                    disabled={!hasPermission}
                  />
                </Col>
                <Col lg={4} md={4} sm={4} xs={12}>
                  <Field
                    name="zipCode"
                    label="Zip Code"
                    component={InputField}
                    disabled={!hasPermission}
                  />
                </Col>
                <Col lg={4} md={4} sm={4} xs={12}>
                  <Field
                    name="district"
                    label="District"
                    component={InputField}
                    disabled={!hasPermission}
                  />
                </Col>
              </Row>
              <Row>
                <Col lg={4} md={4} sm={4} xs={12}>
                  <Field
                    name="city"
                    label="City"
                    component={InputField}
                    disabled={!hasPermission}
                  />
                </Col>
                <Col lg={4} md={4} sm={4} xs={12}>
                  <Field
                    name="state"
                    label="State"
                    component={InputField}
                    disabled={!hasPermission}
                  />
                </Col>
                <Col lg={4} md={4} sm={4} xs={12}>
                  <Field
                    name="country"
                    label="Country"
                    isRequired={contactType && contactType === 30 ? true : false}
                    options={fieldRenderOptions(comboBoxSearch.country ? comboBoxSearch.country : vazio)}
                    searchList={comboBoxSearch.country ? comboBoxSearch.country : vazio}
                    onChange={(e) => { formikProps?.setFieldValue(`country`, e); }}
                    component={ComboBox}
                    disabled={!hasPermission}
                  />
                </Col>
              </Row>  </>} 
            <ButtonContainer>
              <ButtonContent>
                <Button
                  fullWidth
                  onClick={() => goBack()}
                  style={{ marginLeft: 15 }}
                  secundary>
                  Cancel
                </Button>
              </ButtonContent>
              <ButtonContent>
                <Button
                  fullWidth
                  disabled={!hasPermission}
                  style={{ marginLeft: 15 }}
                  type="submit"
                  third
                  id="btnSubmit">
                  Save
                </Button>
              </ButtonContent>
            </ButtonContainer>

          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
};